import { useCallback } from 'react';
import { useSnackbar } from 'ui-components';
import { SHARE_TYPE } from '~/components/SavedListShareModal';
import { TOAST_ERROR_GENERIC } from '~/constants';

const useCopyNotification = (shareLink?: string) => {
  const snackbar = useSnackbar();

  const handleSuccess = useCallback(
    (type: SHARE_TYPE, action: string) => {
      const toastId = shareLink
        ? `${shareLink}${type}${action}`
        : `${type}${action}`;

      let description = 'Link successfully copied';

      if (type === SHARE_TYPE.embed) {
        description = 'Embed successfully copied';
      }

      snackbar.success({
        description,
        duration: 9000,
        id: toastId,
        isCloseable: true,
      });
    },
    [shareLink, snackbar],
  );

  const handleError = useCallback(
    () =>
      snackbar.error({
        description: TOAST_ERROR_GENERIC.description as string,
        duration: 9000,
        isCloseable: true,
      }),
    [snackbar],
  );

  return { handleSuccess, handleError };
};

export default useCopyNotification;
